module.exports = __webpack_public_path__ + "img/opening2.096fdb45.png";